import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface UserFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterRole: 'all' | 'owner' | 'admin' | 'member';
  onRoleChange: (value: 'all' | 'owner' | 'admin' | 'member') => void;
  filterStatus: 'all' | 'active' | 'inactive';
  onStatusChange: (value: 'all' | 'active' | 'inactive') => void;
}

export const UserFilters: React.FC<UserFiltersProps> = ({
  searchTerm,
  onSearchChange,
  filterRole,
  onRoleChange,
  filterStatus,
  onStatusChange
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      {/* Search */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-amber-500 focus:border-amber-500 sm:text-sm"
          placeholder="Search users..."
        />
      </div>

      {/* Role Filter */}
      <select
        value={filterRole}
        onChange={(e) => onRoleChange(e.target.value as any)}
        className="block w-full sm:w-auto pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-amber-500 focus:border-amber-500 sm:text-sm rounded-md"
      >
        <option value="all">All Roles</option>
        <option value="owner">Super Admins</option>
        <option value="admin">Advisors</option>
        <option value="member">Assistants</option>
      </select>

      {/* Status Filter */}
      <select
        value={filterStatus}
        onChange={(e) => onStatusChange(e.target.value as any)}
        className="block w-full sm:w-auto pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-amber-500 focus:border-amber-500 sm:text-sm rounded-md"
      >
        <option value="all">All Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
  );
};